import axios from 'axios';
import { Notistack } from '@shared/components/Notistack/Notistack';
import { SERVICES } from '@shared/constants/apiConfig';
import { IOneClickPayload } from './components/EditOneClickModal';

export const requestCreateOneClickConfiguration = async(values: IOneClickPayload) => {
  try {
    await axios.post(`${SERVICES.LEAD}/oneclick/configuration`, values);
    Notistack.successMessage('One-Click Edit - Created Successfully');
  } catch {
    Notistack.generalError();
  }
};

export const requestUpdateOneClickConfiguration = async(values: IOneClickPayload) => {
  try {
    await axios.put(`${SERVICES.LEAD}/oneclick/configuration/${values.id}`, values);
    Notistack.successMessage('One-Click Edit - Updated Successfully');
  } catch {
    Notistack.generalError();
  }
};
